import React from 'react';

import AppsIcon from '@mui/icons-material/Apps';
import DriveFileRenameOutlineOutlinedIcon from '@mui/icons-material/DriveFileRenameOutlineOutlined';
import { Stack, Typography } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  {
    name: 'Drafts',
    text: 'drafts',
    path: '/drafts',
    icon: <DriveFileRenameOutlineOutlinedIcon />,
  },
  {
    name: 'Data Dictionary',
    text: 'dictionary',
    path: '/dictionary',
    icon: <AppsIcon />,
  },
];

const SideBar = () => {
  const { pathname } = useLocation();
  return (
    <Stack
      sx={{
        width: '80px',
        boxShadow: '1px 0px 0px 0px #00000040',
        padding: '10px',
        alignItems: 'center',
        paddingTop: '25px',
      }}
      gap={4}
    >
      {navItems.map((item, index) => (
        <Stack
          key={index}
          sx={{
            alignItems: 'center',
            color: pathname.includes(item.text) ? '#88305F' : '#49454F',
            cursor: 'pointer',
          }}
          component={Link}
          to={item.path}
          gap="5px"
        >
          {item.icon}
          <Typography
            variant="caption"
            sx={{ display: 'block', textAlign: 'center', fontWeight: 600 }}
          >
            {item.name}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
};

export default SideBar;
